import { CONTAINER, SERIF } from "../tokens";

// Rangée de chiffres clés séparés par des filets verticaux. Sous 780px le
// handoff remplace ces filets par une bordure basse et supprime le padding
// horizontal — rendu ici par les variantes `md:` (le point de rupture
// Tailwind le plus proche).
export default function KeyFiguresSection({ blocks = [] }) {
  const items = (blocks || []).filter((b) => b.type === "figure_item" && b.enabled !== false);
  if (!items.length) return null;

  return (
    <section className={`${CONTAINER} pt-[88px] pb-[92px]`}>
      <div className="grid border-t border-ink/[0.14] [grid-template-columns:repeat(auto-fit,minmax(200px,1fr))]">
        {items.map((b, i) => (
          <div
            key={b.id}
            data-block-key={b.id}
            className={`py-7 border-b border-ink/[0.09] md:border-b-0 md:px-[22px] ${
              i === items.length - 1 ? "" : "md:border-r md:border-ink/[0.09]"
            } ${i === 0 ? "md:pl-0" : ""} ${i === items.length - 1 ? "md:pr-0" : ""}`}
          >
            <div className="text-[46px] leading-none tracking-[-0.02em] text-ink" style={{ fontFamily: SERIF }}>
              {b.props?.value}
            </div>
            <div className="text-[14.5px] text-ink/[0.58] mt-2.5">{b.props?.caption}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
